import { UI_PRIMITIVE__switch } from '@/components/ui/UI_PRIMITIVE__switch';
import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import { use_slice_generation, use_slice_ui, use_slice_user } from '@/hooks/store/use_slices';
import { FN_USER_SETTINGS__update } from '@/utils/utils_client';
import { ENUM__page_generation_layout } from '../../_enums/ENUM__page_generation_layout';
import { G_VIEW__generation_contains_errors } from './button_generation/_views/G_VIEW__generation_contains_errors';

interface PROPS {}

export function G_SWITCH__generation_graph_autorun_nodes({}: PROPS) {
  /*
   * STORE
   */
  const { user_settings } = use_slice_user(['user_settings']);
  const { generation_current } = use_slice_generation(['generation_current']);
  const { g_general__layout } = use_slice_ui(['g_general__layout']);

  /*
   * STATE
   */
  const is_checked = user_settings.generation_autorun;

  /*
   * EVENTS
   */
  async function onClick() {
    let user_settings_new = user_settings.clone();
    user_settings_new.generation_autorun = !user_settings_new.generation_autorun;

    await FN_USER_SETTINGS__update(user_settings_new);
  }

  /*
   * METHODS
   */

  function get_text() {
    let out = '';

    if (CONSTANTS__client.LAYOUTS_WITH_AUTORUN.includes(g_general__layout)) {
      out = is_checked ? 'Autorun on' : 'Autorun off';
    } else {
      out = 'Autorun';
    }

    return out;
  }

  function is_disabled() {
    return;
  }

  /*
   * HTML
   */

  if (user_settings.is_stub()) return null;
  if (generation_current.is_stub()) return null;
  if (!generation_current.tool.graph.meta.errors.is_empty()) return <G_VIEW__generation_contains_errors />;

  return (
    <>
      <div
        className={`flex flex-col gap-2 flex-center 
          flex-1 h-full 
          cursor-pointer
          ${g_general__layout == ENUM__page_generation_layout.OUTPUTS ? 'opacity-100' : 'opacity-50 hover:opacity-100'}
        `}
        {...{ onClick }}
      >
        <div className="h-4 w-8">
          <UI_PRIMITIVE__switch checked={is_checked} class_name_thumb={is_checked ? 'bg-purchase' : ''} />
        </div>
        <span className={`w-full text-center text-xs ${is_checked ? 'text-purchase' : 'text-bar-foreground'}`}>{get_text()}</span>
      </div>
    </>
  );
}
